import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Header from '../../includes/Header';
import Footer from '../../includes/Footer';
import { Col, Container, Row } from 'react-bootstrap';
import Loader from '../../components/Loader/Loader';
import { FaArrowRight } from "react-icons/fa6";

import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/thumbs';
import 'swiper/css/navigation';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Thumbs, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { ToastContainer, toast } from 'react-toastify';
import { categoryWiseProductwithFilter } from '../../apiservices/ApiServices';
import { useCartWishlist } from '../CartWishlistContext';
import ProductCard from '../../components/ProductCard/ProductCard';
import useScrollRestoration from '../useScrollRestoration';

const Categorie = () => {
    const location = useLocation();
    const subPath = location.pathname.split('/');
    const slug = subPath[subPath.length - 1];
    const title = slug.replace(/-/g, ' ');
    const [isLoading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [isMsg, setIsMsg] = useState(false);
    const [msg, setMsg] = useState('');
    const { cart, setCart, wishlist, isLogin, setIsLogin, addToCart, toggleWishlist } = useCartWishlist();
    useScrollRestoration(!isLoading);

    const categoryWiseProductwithFilters = async (postData) => {
        setLoading(true);
        try {
            const res = await categoryWiseProductwithFilter(postData);
            setData(res.data.data);
            setLoading(false);
        } catch (error) {
            setIsMsg(true);
            setMsg(error.response.data.message);
            setLoading(false);
        }
    };

    useEffect(() => {
        setData([]);
        setIsMsg(false);
        setMsg('');

        let postData = {
            category_slug: slug,
        }
        categoryWiseProductwithFilters(postData);
    }, [slug]);
    return (
        <>
            <Header toast={toast} />
            <ToastContainer />
            {isLoading ? (<Loader />) : (
                <>
                    <div className="crumbsec">
                        <div className="wrap">
                            <Link to={'/'}>Home</Link>
                            <span className="sep">&rsaquo;</span>
                            <Link to={'/categories'}>Categories</Link>
                            <span className="sep">&rsaquo;</span>
                            <span className="cur">{title}</span>
                        </div>
                    </div>

                    {/* <section id='bannerbox' className="hero">
                        <div className="hero-glow"></div>
                        <div className="wrap">
                            <div className="hero-left reveal">
                                <h1 className="hero-title">{data?.main_category?.name}</h1>
                                <div className="hero-sub" dangerouslySetInnerHTML={{ __html: data?.main_category?.description }}></div>
                            </div>
                            <div className="hero-art reveal d2">
                                <span className="ring r1"></span><span className="ring r2"></span>
                                <svg className="h-glass" viewBox="0 0 170 250">
                                    <defs>
                                        <linearGradient id="hg" x1="0" y1="0" x2="1" y2="1">
                                            <stop offset="0" stopColor="#7fe9d4" stopOpacity=".28" />
                                            <stop offset="1" stopColor="#0c1a17" stopOpacity=".1" />
                                        </linearGradient>
                                    </defs>
                                    <rect x="35" y="8" width="100" height="234" rx="22" fill="url(#hg)" stroke="rgba(25, 29, 28, 0.55)"
                                        stopOpacity="2" />
                                    <rect x="55" y="34" width="34" height="5" rx="2.5" fill="rgba(18,191,160,.5)" />
                                </svg>
                                <svg className="h-phone" viewBox="0 0 170 250">
                                    <defs>
                                        <linearGradient id="hp" x1="0" y1="0" x2="0" y2="1">
                                            <stop offset="0" stopColor="#2a3742" />
                                            <stop offset="1" stopColor="#0c1116" />
                                        </linearGradient>
                                    </defs>
                                    <rect x="35" y="6" width="100" height="238" rx="26" fill="url(#hp)" stroke="#3a4a56" stopOpacity="1.5" />
                                    <rect x="44" y="16" width="56" height="56" rx="16" fill="#0a0f13" />
                                    <circle cx="60" cy="32" r="9" fill="#1c2831" />
                                    <circle cx="60" cy="32" r="4" fill="#4de0c4" opacity=".5" />
                                    <circle cx="84" cy="32" r="9" fill="#1c2831" />
                                    <circle cx="84" cy="32" r="4" fill="#4de0c4" opacity=".5" />
                                    <circle cx="60" cy="56" r="9" fill="#1c2831" />
                                    <circle cx="85" cy="130" r="20" fill="none" stroke="rgba(77,224,196,.55)" stopOpacity="2.5" />
                                </svg>

                                <svg className="h-rings" viewBox="0 0 170 250">
                                    <g transform="translate(0,50)">
                                        <circle cx="60" cy="40" r="26" fill="#12171b" stroke="#3a4a56" stopOpacity="3" />
                                        <circle cx="60" cy="40" r="14" fill="#0a0e11" />
                                        <circle cx="110" cy="90" r="26" fill="#12171b" stroke="rgba(77,224,196,.6)" stopOpacity="3" />
                                        <circle cx="110" cy="90" r="14" fill="#0a0e11" />
                                        <circle cx="60" cy="140" r="26" fill="#12171b" stroke="#3a4a56" stopOpacity="3" />
                                        <circle cx="60" cy="140" r="14" fill="#0a0e11" />
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </section> */}

                    <section id='collections'>
                        <div className='collections-block'>
                            <Container>
                                {data.map((dataitem) => {
                                    return (
                                        <section key={dataitem.id || dataitem.slug} className="prod-section">
                                            <div className="sec-head">
                                                <h2 className="sec-title">Choose Your <span className="teal">{dataitem.name}</span></h2>
                                                <Link to={`/product/categories/${dataitem.slug}`} className="cat-link">View All <FaArrowRight /></Link>
                                            </div>
                                            <div className='relatedproducts-box'>
                                                <Swiper
                                                    modules={[Navigation, Pagination, Scrollbar, A11y]}
                                                    spaceBetween={0}
                                                    slidesPerView={5}
                                                    navigation
                                                    pagination={{ clickable: true }}
                                                    scrollbar={{ draggable: true }}
                                                    breakpoints={{
                                                        1200: { slidesPerView: 5 },
                                                        1024: { slidesPerView: 4 },
                                                        768: { slidesPerView: 3 },
                                                        640: { slidesPerView: 2 },
                                                        401: { slidesPerView: 2 },
                                                        300: { slidesPerView: 2 },
                                                    }}
                                                >
                                                    {dataitem?.products?.map((item, ind) => (
                                                        <SwiperSlide key={`prod_${item?.product_id}_${ind}`}>
                                                            <ProductCard
                                                                PlanName={item?.eligible_plan_name}
                                                                PlanContent={item?.thumbnail_description}
                                                                Name={item.name}
                                                                SkuID={item.sku_id}
                                                                ImgUrl={item?.media_list[0]?.media_url}
                                                                Offer={item.discount_per}
                                                                Price={item.price}
                                                                OldPrice={item.actual_price}
                                                                ProductSlug={item.slug}
                                                                ProductLabel={item?.product_label}
                                                                Quantitys={item.quantity}
                                                                Brands={item?.brands?.name}
                                                                Model={item?.model?.name}
                                                                Cart={cart}
                                                                Wishlist={wishlist}
                                                                ToggleWishlist={toggleWishlist}
                                                                addToCart={addToCart}
                                                            />
                                                        </SwiperSlide>
                                                    ))}
                                                </Swiper>
                                            </div>
                                        </section>
                                    );
                                })}
                            </Container>
                        </div>
                    </section>
                </>
            )}
            <Footer toast={toast} />
        </>
    )
}

export default Categorie